<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content style="min-width: 400px; max-width: 600px;">
  <t4-container title="{{ 'turbo.core.entityattachment.lblAttachmentDetails' | translate : 'Attachment Details'}}" [isLoading]="isLoading">
    <div class="form-group">
      <label>{{ 'turbo.core.entityattachment.lblSubject' | translate : 'Subject'}}:</label> {{ entityAttachments[0]?.Subject }}
    </div>
    <div class="form-group">
      <label>{{ 'turbo.core.entityattachment.lblSentTo' | translate : 'Sent To'}}:</label> {{ entityAttachments[0]?.SentTo }}
    </div>
    <div class="form-group">
      <label>{{ 'turbo.core.entityattachment.lblCreatedAt' | translate : 'Created At'}}:</label> {{ entityAttachments[0]?.CreatedAt | date:'short' }}
    </div>
    <div class="form-group">
      <label>{{ 'turbo.core.entityattachment.lblContent' | translate : 'Content'}}:</label>
      <div class="content-box" [innerHTML]="entityAttachments[0]?.Content"></div>
    </div>
  </t4-container>
</mat-dialog-content>
  
